/* eslint react-hooks/rules-of-hooks: "off" */
import EnumBase from './Base';

export default function partnerStatusEnum(){
  return new EnumBase([
    { name: 'Aprovado', id: 'approved'},
    { name: 'Processando', id: 'processing'},
    { name: 'Cancelado', id: 'canceled'},
  ]);
}